import PropTypes from "prop-types";
import { Button, Spinner } from "reactstrap";
import useUser from "../../../../../core/hooks/use-user";
import { exportarCuadroTurnos } from "../../../services/nomina-cuadro-turnos";
import { toast } from "../../../../../core/helpers/message-helper";
import { downloadFile } from "../../../../../core/helpers/files-helper";
import { API_DOMAIN } from "../../../../../core/config/env";
import { useState } from "react";

const BotonExportarCuadroTurnos = ({ filtros }) => {
    const { userCan } = useUser();
    const [cargando, setCargando] = useState(false);
    const { sedeAreaLider, startDate, endDate, subAreasLider, turnos } =
        filtros;

    const exportar = async () => {
        try {
            setCargando(true);
            toast.info("Generando archivo...");
            const resp = await exportarCuadroTurnos(
                startDate,
                endDate,
                sedeAreaLider,
                subAreasLider,
                turnos
            );

            if (!resp.status) return toast.error(resp.message);
            downloadFile(`${API_DOMAIN}/${resp.data}`);
            setCargando(false);
        } catch (error) {
            setCargando(false);
        }
    };

    if (userCan("nominaExportarCuadroTurno")) {
        return (
            <>
                <Button
                    color="success"
                    className="ml-2"
                    title="Exportar cuadro de turnos a Excel"
                    onClick={() => exportar()}
                    disabled={cargando}
                >
                    {cargando ? (
                        <Spinner size="sm" />
                    ) : (
                        <i className="fas fa-file-excel"></i>
                    )}
                </Button>
            </>
        );
    }

    return <></>;
};

BotonExportarCuadroTurnos.propTypes = {
    filtros: PropTypes.object,
};

export default BotonExportarCuadroTurnos;
